export var EventTypeCode;
(function (EventTypeCode) {
    EventTypeCode[EventTypeCode["Unknown"] = 0] = "Unknown";
    EventTypeCode[EventTypeCode["NoDataConnection"] = 1] = "NoDataConnection";
    EventTypeCode[EventTypeCode["DataConnectionRestored"] = 2] = "DataConnectionRestored";
    EventTypeCode[EventTypeCode["DeviceConnectionLost"] = 3] = "DeviceConnectionLost";
    EventTypeCode[EventTypeCode["SlowMovementPause"] = 4] = "SlowMovementPause";
    EventTypeCode[EventTypeCode["RapidMovements"] = 5] = "RapidMovements";
    EventTypeCode[EventTypeCode["LeftBedInformation"] = 6] = "LeftBedInformation";
    EventTypeCode[EventTypeCode["LeftBed"] = 7] = "LeftBed";
    EventTypeCode[EventTypeCode["ExceededReturnDelay"] = 8] = "ExceededReturnDelay";
    EventTypeCode[EventTypeCode["ReturnedToBed"] = 9] = "ReturnedToBed";
    EventTypeCode[EventTypeCode["NotYetInBed"] = 10] = "NotYetInBed";
    EventTypeCode[EventTypeCode["StillInBed"] = 11] = "StillInBed";
    EventTypeCode[EventTypeCode["MorningBedExit"] = 12] = "MorningBedExit";
    EventTypeCode[EventTypeCode["Afternoon"] = 13] = "Afternoon";
    EventTypeCode[EventTypeCode["EveningPresent"] = 14] = "EveningPresent";
    EventTypeCode[EventTypeCode["EveningSeen"] = 15] = "EveningSeen";
    EventTypeCode[EventTypeCode["EveningNotSeen"] = 16] = "EveningNotSeen";
    EventTypeCode[EventTypeCode["DeviceEvent"] = 17] = "DeviceEvent";
    EventTypeCode[EventTypeCode["OngoingSensorError"] = 18] = "OngoingSensorError";
    EventTypeCode[EventTypeCode["SittingInBed"] = 19] = "SittingInBed";
    EventTypeCode[EventTypeCode["StillInBedDidNotLeave"] = 20] = "StillInBedDidNotLeave";
    EventTypeCode[EventTypeCode["NoTurningStart"] = 21] = "NoTurningStart";
    EventTypeCode[EventTypeCode["NoTurningEnd"] = 22] = "NoTurningEnd";
    EventTypeCode[EventTypeCode["IntentionToLeaveStart"] = 23] = "IntentionToLeaveStart";
    EventTypeCode[EventTypeCode["IntentionToLeaveEnd"] = 24] = "IntentionToLeaveEnd";
    EventTypeCode[EventTypeCode["Moving"] = 25] = "Moving";
    EventTypeCode[EventTypeCode["MayHaveFallen"] = 26] = "MayHaveFallen";
    EventTypeCode[EventTypeCode["NotDetected"] = 27] = "NotDetected";
    EventTypeCode[EventTypeCode["PirDisconnected"] = 28] = "PirDisconnected";
    EventTypeCode[EventTypeCode["PirConnected"] = 29] = "PirConnected";
    EventTypeCode[EventTypeCode["RestlessStart"] = 30] = "RestlessStart";
    EventTypeCode[EventTypeCode["RestlessEnd"] = 31] = "RestlessEnd";
    EventTypeCode[EventTypeCode["MovingAgain"] = 32] = "MovingAgain";
    EventTypeCode[EventTypeCode["ProlongedNetworkError"] = 33] = "ProlongedNetworkError";
    EventTypeCode[EventTypeCode["MovementStarted"] = 34] = "MovementStarted";
    EventTypeCode[EventTypeCode["MovementStopped"] = 35] = "MovementStopped";
    EventTypeCode[EventTypeCode["FallAsleep"] = 36] = "FallAsleep";
    EventTypeCode[EventTypeCode["SnoringStart"] = 37] = "SnoringStart";
    EventTypeCode[EventTypeCode["SnoringEnd"] = 38] = "SnoringEnd";
    EventTypeCode[EventTypeCode["NoTurningDetected"] = 43] = "NoTurningDetected";
    EventTypeCode[EventTypeCode["PositionChanged"] = 44] = "PositionChanged";
    EventTypeCode[EventTypeCode["MotionPassive"] = 71] = "MotionPassive";
    EventTypeCode[EventTypeCode["MotionActive"] = 72] = "MotionActive";
    EventTypeCode[EventTypeCode["MotionHeartBeat"] = 92] = "MotionHeartBeat";
    EventTypeCode[EventTypeCode["SystemError"] = 127] = "SystemError";
    EventTypeCode[EventTypeCode["MotionStatus"] = 129] = "MotionStatus";
    EventTypeCode[EventTypeCode["SensorError"] = 161] = "SensorError";
    EventTypeCode[EventTypeCode["DeviceError"] = 254] = "DeviceError";
    EventTypeCode[EventTypeCode["SystemErrorAcknowledged"] = 1127] = "SystemErrorAcknowledged";
})(EventTypeCode || (EventTypeCode = {}));
export const EventGroups = {
    errors: [1, 3, 18, 33, 127, 161, 254],
    movement: [4, 5, 25, 32, 44],
    absence: [6, 7, 8, 9, 19, 20, 21, 22, 23, 24, 26, 27, 43],
    night: [10, 11, 12, 13, 14, 15, 16, 17],
    pir: [28, 29, 34, 35, 71, 72, 92, 129],
    restless: [30, 31],
    sleep: [36, 37, 38],
};
//# sourceMappingURL=event.interface.js.map